<template>
  <splitpanes class="default-theme">

    <pane min-size="10" max-size="25" size="20">
      <div style="display:inline-flex;border: 1px solid #e5e5e5;line-height: 30px;font-size: smaller ">
        <el-button size="small" style="width: 60px;margin-top:5px; margin-right:105px;" @click="searchOrders">刷新订单</el-button>
        <div style="width:45px;padding-left:3px; background-color: #6699CC ">总数量</div>
        <div style="width:45px;padding-left:3px; background-color: lightseagreen">已生产</div>
        <div style="width:45px;padding-left:3px; background-color: #95d475">已排产</div>
        <div style="width:45px;padding-left:3px; background-color: plum">待排产</div>
      </div>

      <div class="scrollbar" style="overflow-y: auto;height:90%;">
        <draggable :list="orderList" ghost-class="ghost" chosen-class="chosenClass"
                   animation="300" :group="{ name: 'items', pull: 'clone' }"
                   :sort="false">
          <template #item="{ element }">
            <div class="item button1 cursor" style="padding: 5px;margin-top: 3px;border: 1px solid whitesmoke">
              <div>
                <span>{{ element.order_id }}</span>
                <span style="margin-left: 20px">{{ element.customer_name }}</span>
              </div>

              <div style="display:inline-flex;border: 1px solid #e5e5e5; ">
                <div style="width:160px;padding-left:3px;" >{{element.product_name}}</div>
                <div style="width:45px;padding-left:3px; background-color: #6699CC ">{{element.total_qty}}</div>
                <div style="width:45px;padding-left:3px; background-color: lightseagreen">{{element.finish_qty}}</div>
                <div style="width:45px;padding-left:3px; background-color: #95d475">{{element.scheduled_qty}}</div>
                <div style="width:45px;padding-left:3px; background-color: plum">{{element.wait_schedule_qty}}</div>
              </div>
            </div>
          </template>
        </draggable>
      </div>

    </pane>

    <pane min-size="50" style="background-color: white">
        <div>
          <el-row style="height: 37px;overflow-y: auto;margin-left: 5px;" class="border center">
            <el-col :span="24" style="text-align: center;margin-top: 2px">
              <el-button size="small" class="week" @click="searchCurrentWeek">本周</el-button>
              <el-button size="small" class="week"  @click="searchPreWeek"><el-icon><ElIconArrowLeft /></el-icon>上周</el-button>
              <el-button size="small" class="week" @click="searchNextWeek">下周<el-icon><ElIconArrowRight /></el-icon></el-button>
              <el-button size="small" style="width: 60px;" type="primary" @click="saveAllDate">保存</el-button>
            </el-col>
          </el-row>
        </div>

      <div ref="total_height" style="display: flex;height: 95%;width: 100%;overflow-x: auto;">
        <div style="width:220px;min-width: 220px;max-width: 220px" v-for="item in scheduleDateList" :key="item">
          <div class="border color time" style="width:100%; text-align:center; border: 1px solid #e5e5e5 ">
            <span >{{ item.schedule_date }}</span>
            <span style="margin-left: 10px">{{ item.week }}</span>
          </div>
          <div v-if="item.lineList" class="data_style">
            <div v-for="lineInfo in item.lineList" :key="id" style="border: 1px solid #e5e5e5;min-height: 300px " >
              <div style="width:100%; text-align:center; background-color: lightgrey">
                {{lineInfo.name}}
              </div>
                <draggable :list="lineInfo.scheduleList" :class="lineInfo.id"
                           ghost-class="ghost" chosen-class="chosenClass" animation="300"
                           :sort="true" group="items" @change="onRightChange" @add="onAdd">
                  <template #item="{ element }">
                    <div class="item button1 cursor" style="margin-top: 3px;border: 1px solid lightskyblue">
                      <div style="display:inline-flex; ">
                        <div style="width:60px;padding-left:3px; " >{{element.order_id}}</div>
                        <div style="width:138px;padding-left:3px;overflow-x: hidden" >{{element.customer_name}}</div>
                        <el-button style="width: 16px;height: 16px;margin-top: 3px" size="small" icon="el-icon-edit" circle @click="showEditSchedule(element, lineInfo, item)"></el-button>
                      </div>

                      <div style="display:inline-flex;margin-top: 3px;border: 1px solid #e5e5e5; ">
                        <div style="width:147px;padding-left:3px; " >{{element.product_name}}</div>
                        <div style="width:35px;padding-left:3px;background-color: #95d475 " >{{element.plan_qty}}</div>
                        <div style="width:35px;padding-left:3px;background-color: lightseagreen" >{{element.actual_finish_qty}}</div>
                      </div>

                      <div style="display:inline-flex;margin-top: 3px;">
                        <div style="padding-left:3px; " >{{element.remark}}</div>
                      </div>
                    </div>
                  </template>
                </draggable>
            </div>
          </div>
        </div>
      </div>
    </pane>

  </splitpanes>

  <el-dialog title="排产编辑" v-model="showDialogEdit" width="600px" height="500px" >
    <el-form label-width="130px">
      <el-form-item label="产线名称">
        <el-input v-model="editData.line_name" readonly></el-input>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产日期">
            <el-input v-model="editData.schedule_date" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="星期">
            <el-input v-model="editData.schedule_week" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="订单编号">
            <el-input v-model="editData.order_id" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称">
            <el-input v-model="editData.product_name" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="待排产数量">
            <el-input v-model="editData.wait_schedule_qty" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="每小时产能">
            <el-input v-model="editData.hour_capacity" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产数量">
            <el-input v-model="editData.plan_qty" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作业时长">
            <el-input v-model="editData.work_hour" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="备注">
        <el-input v-model="editData.remark" ></el-input>
      </el-form-item>
    </el-form>

    <el-row>
      <el-col :span="24">
        <el-form-item label="">
          <el-button type="primary" style="margin-left: 130px" size="small" >保存</el-button>
          <el-button type="danger" size="small" >删除</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import draggable from "vuedraggable";

export default {
  name: "MesSchedule",
  components: {Splitpanes, Pane, draggable},
  data() {
    return {
      orderList: [],
      week_gap: 0,
      scheduleDateList: [],
      addData: {parentId: '', name: ''},
      folderData: [],
      currentFolder: {},
      subPage: 'user',
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      docList: [],
      showDialogAdd:false,
      showDialogEdit: false
    }
  },
  computed: {
    queryParam() {
      return {
        dir_id: this.currentFolder.id,
        dir_name: this.currentFolder.name
      }
    }
  },
  methods: {
    async searchOrders() {
      this.orderList = await this.$http('aiOrderService.getOrderItems', {});
    },
    async searchSchedule() {
      this.scheduleDateList = await this.$http('aiScheduleDbService.getScheduleData', {"week_gap":this.week_gap});
    },
    async searchCurrentWeek() {
      this.week_gap = 0;
      this.searchSchedule();
    },
    async searchPreWeek() {
      this.week_gap = this.week_gap - 1;
      this.searchSchedule();
    },
    async searchNextWeek() {
      this.week_gap = this.week_gap + 1;
      this.searchSchedule();
    },
    onAdd(event) {
      console.log(event)
      var draggedItem = event.item._underlying_vm_;
      var toClassName = event.to.className;
      console.log(draggedItem)
      console.log(toClassName)
    },
    onRightChange(event) {
      if (event.added) {
        // 右侧触发添加方法
        console.log('Item added to right list:', event.added.element);
      }
    },
    showEditSchedule(schedule, lineInfo, item) {
      this.editData = schedule;
      this.editData.line_id = lineInfo.id;
      this.editData.line_name = lineInfo.name;
      this.editData.schedule_date = item.schedule_date;
      this.editData.schedule_week = item.week;
      this.showDialogEdit = true;
    },
  },
  created() {
    this.searchOrders();
    this.searchSchedule();
  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.folderButton {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

</style>
